__turbopack_context__.v({
  "badge": "_3e-gpW_badge",
  "badgeEmployment": "_3e-gpW_badgeEmployment",
  "badgeLight": "_3e-gpW_badgeLight",
  "contactDisclaimer": "_3e-gpW_contactDisclaimer",
  "contactField": "_3e-gpW_contactField",
  "contactFieldError": "_3e-gpW_contactFieldError",
  "contactFieldLabel": "_3e-gpW_contactFieldLabel",
  "contactFormRow": "_3e-gpW_contactFormRow",
  "contactInput": "_3e-gpW_contactInput",
  "contactInputError": "_3e-gpW_contactInputError",
  "contactModal": "_3e-gpW_contactModal",
  "contactModalForm": "_3e-gpW_contactModalForm",
  "contactModalHeader": "_3e-gpW_contactModalHeader",
  "contactModalSubmit": "_3e-gpW_contactModalSubmit",
  "contactModalSubtitle": "_3e-gpW_contactModalSubtitle",
  "contactModalTitle": "_3e-gpW_contactModalTitle",
  "contactTextarea": "_3e-gpW_contactTextarea",
  "jobBadges": "_3e-gpW_jobBadges",
  "jobCard": "_3e-gpW_jobCard",
  "jobCardActions": "_3e-gpW_jobCardActions",
  "jobCardInfo": "_3e-gpW_jobCardInfo",
  "jobCardMain": "_3e-gpW_jobCardMain",
  "jobCompany": "_3e-gpW_jobCompany",
  "jobDetailActions": "_3e-gpW_jobDetailActions",
  "jobDetailBadges": "_3e-gpW_jobDetailBadges",
  "jobDetailBody": "_3e-gpW_jobDetailBody",
  "jobDetailCol": "_3e-gpW_jobDetailCol",
  "jobDetailHeader": "_3e-gpW_jobDetailHeader",
  "jobDetailLabel": "_3e-gpW_jobDetailLabel",
  "jobDetailList": "_3e-gpW_jobDetailList",
  "jobDetailModal": "_3e-gpW_jobDetailModal",
  "jobDetailRow": "_3e-gpW_jobDetailRow",
  "jobDetailSection": "_3e-gpW_jobDetailSection",
  "jobDetailSectionTitle": "_3e-gpW_jobDetailSectionTitle",
  "jobDetailTitle": "_3e-gpW_jobDetailTitle",
  "jobShortDesc": "_3e-gpW_jobShortDesc",
  "jobTitle": "_3e-gpW_jobTitle",
  "jobs": "_3e-gpW_jobs",
  "jobsDivider": "_3e-gpW_jobsDivider",
  "jobsList": "_3e-gpW_jobsList",
  "modal": "_3e-gpW_modal",
  "modalOverlay": "_3e-gpW_modalOverlay",
  "resumeFileName": "_3e-gpW_resumeFileName",
  "resumeInputHidden": "_3e-gpW_resumeInputHidden",
  "resumeUpload": "_3e-gpW_resumeUpload",
  "resumeUploadButton": "_3e-gpW_resumeUploadButton",
  "videoThumbnailLogo": "_3e-gpW_videoThumbnailLogo",
});
